var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_7161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.10573 9.85498L0.828125 12.7574C0.951051 14.6032 1.53247 16.3893 2.51973 17.9538L6.87453 18.3762L8.65893 15.9202L7.29332 10.8894L4.10573 9.85498Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8802 18.8154L17.2098 19.1714L15.7354 22.5574C17.7747 21.8313 19.5611 20.532 20.8802 18.8154Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5992 15.5986L15.916 10.7482L12 8.08301L8.08398 10.7482L9.40038 15.5986H14.5992Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4803 18.8459L14.6999 16.3999H9.29988L7.52148 18.8471L9.27068 22.8635C11.0618 23.3136 12.9364 23.3136 14.7275 22.8635L16.4803 18.8459Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26612 22.5574L6.79132 19.1714L3.12012 18.8154C4.43944 20.5322 6.22632 21.8315 8.26612 22.5574Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77522 5.6582C1.54488 7.44013 0.861083 9.54226 0.807617 11.707L3.57042 9.2602L2.77522 5.6582Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56296 10.1358L11.6002 7.38818V3.82818L7.82776 1.60938C6.11358 2.3014 4.59633 3.40513 3.41016 4.82298L4.35336 9.09418L7.56296 10.1358Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1929 11.7074C23.1394 9.54255 22.4556 7.4403 21.2253 5.6582L20.4297 9.2606L23.1929 11.7074Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1822 1.263C13.1055 0.645406 10.894 0.645406 8.81738 1.263L11.9998 3.1358L15.1822 1.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 7.38818L16.438 10.1358L19.6472 9.09578L20.59 4.82418C19.404 3.40581 17.8867 2.30164 16.1724 1.60938L12.4004 3.82898V7.38818Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1716 12.7574L19.894 9.85498L16.7064 10.8894L15.3408 15.9202L17.1248 18.3754L21.48 17.9538C22.4672 16.3893 23.0486 14.6032 23.1716 12.7574Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_7161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocr);
export default __webpack_public_path__ + "static/media/SOCR.abcab6d755adae3c8b7e67c375173871.svg";
export { ForwardRef as ReactComponent };